import React, { useEffect, useState } from "react";
import UploadImageModal from "./modals/UploadImageModal";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { Dropdown } from "react-bootstrap";
import { GearFill, Plus } from "react-bootstrap-icons";
import DeleteImageModal from "./modals/DeleteImageModal";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import UploadProfileImgModal from "./modals/UploadProfileImgModal";
import DeleteProfileImgModal from "./modals/DeleteProfileImgModal";
import { useNavigate } from "react-router-dom";

export default function ClubImages({ pendingclub, reviewPendingClub, changeView }) {
  const [uploadImageModal, setUploadImageModal] = useState(false);
  const [images, setImages] = useState([]);
  const { user, dispatch } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(false);
  const [deleteImageModal, setDeleteImageModal] = useState(false);
  const [uploadProfileImgModal, setUploadProfileImgModal] = useState(false);
  const [deletePropfileImgModal, setDeleteProfileImgModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let timeout;
    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [user]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${ApiConnectionString}/api/PendingImages`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      if (res.status === 200) {
        const ordered = res.data.sort((a, b) => a.index - b.index);
        setImages(ordered);
      }
    } catch (err) {
      if (err.status === 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const cancelModal = () => {
    setUploadImageModal(false);
    setDeleteImageModal(false);
    setUploadProfileImgModal(false);
    setDeleteProfileImgModal(false);
  };

  const handleEnableEdit = async () => {
    setIsLoading(true);
    try {
      const response = await axios.put(
        `${ApiConnectionString}/api/pendingClub/EnableEdit?ImagesNotSubmitted=true`,
        null,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (response.status === 200) {
        reviewPendingClub();
      }
    } catch (error) {
      console.error("Error enabling edit:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const res = await axios.put(`${ApiConnectionString}/api/pendingClub/EnableEdit?ImagesSubmitted=true`, null, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      if (res.status === 200) {
        reviewPendingClub();
      }
    } catch (err) {
      console.error("Submit error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const mainImageFunc = async (id) => {
    setIsLoading(true);
    try {
      const res = await axios.put(`${ApiConnectionString}/api/PendingImage/MainImage/${id}`, null, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      if (res.status === 200) {
        fetchData();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <LoadingSpinner />;

  if (pendingclub.imagesSubmitted) {
    return (
      <div>
          <button
        className="floating-back-button"
        onClick={() => changeView("clubInfo")}
      >
        ← Back to Club Info
      </button>
        <div className="lightBlueBanner">
          <p className="fw-bold p-2">Club Images</p>
        </div>
        <p>Images submitted. Click "Edit" to change them.</p>

        <div className="row g-2 mt-3">
          <div className="col-12">
            <h6 className="fw-bold">Profile Image</h6>
            <img
              src={pendingclub.image ? `${ApiConnectionString}/api/pendingclub/profile/${pendingclub.id}` : NoImagePlaceholder}
              alt="Profile"
              className="rounded-circle border mb-3"
              style={{ width: "150px", height: "150px", objectFit: "cover" }}
            />
          </div>
          {images.map((img) => (
            <div className="col-6 col-md-4" key={img.id}>
              <img
                src={`${ApiConnectionString}/api/PendingImage/${img.id}`}
                alt="Club"
                className="img-fluid rounded border"
                style={{ aspectRatio: '1/1', objectFit: 'cover' }}
              />
            </div>
          ))}
        </div>

        <div className="mt-3 d-flex justify-content-between">
          <button className="pointer cancelButton fw-bold" onClick={handleEnableEdit}>Edit</button>
        
          <button className="blue-button" onClick={() => changeView("classes")}>Continue</button>
        </div>
      </div>
    );
  }

  return (
    <div className="container my-4">
                <button
        className="floating-back-button"
        onClick={() => changeView("clubInfo")}
      >
        ← Back to Club Info
      </button>
      <div className="row g-4">
        <div className="col-md-4">
          <div className="card h-100">
            <div className="card-header bg-primary text-white fw-bold">Profile Image</div>
            <div className="card-body text-center">
              <img
                src={pendingclub.image ? `${ApiConnectionString}/api/pendingclub/profile/${pendingclub.id}` : NoImagePlaceholder}
                className="rounded-circle img-fluid mb-3"
                style={{ width: "150px", height: "150px", objectFit: "cover" }}
                alt="Club"
              />
              <button className="btn btn-outline-primary w-100 mb-2" onClick={() => setUploadProfileImgModal(true)}>
                {pendingclub.image ? "Change Profile Image" : "Upload Profile Image"}
              </button>
              {pendingclub.image && (
                <Dropdown>
                  <Dropdown.Toggle as="span" className="dropdown-toggle-custom">
                    <GearFill style={{ cursor: "pointer" }} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setUploadProfileImgModal(true)}>Change</Dropdown.Item>
                    <Dropdown.Item onClick={() => setDeleteProfileImgModal(true)}>Delete</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="card h-100">
            <div className="card-header bg-primary text-white fw-bold">Club Images</div>
            <div className="card-body">
              <button className="btn btn-outline-primary w-100 mb-3" onClick={() => setUploadImageModal(true)}>
                Upload Club Images
              </button>
              <div className="row g-2">
                {images.map((image, idx) => (
                  <div className="col-6 col-md-4" key={image.id}>
                    <div className="position-relative">
                      <Dropdown className="position-absolute top-0 end-0">
                        <Dropdown.Toggle as="span" className="dropdown-toggle-custom">
                          <GearFill
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedImage(image)}
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => mainImageFunc(image.id)}>Make Main Image</Dropdown.Item>
                          <Dropdown.Item onClick={() => setDeleteImageModal(true)}>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      <img
                        src={`${ApiConnectionString}/api/PendingImage/${image.id}`}
                        alt="Club"
                        className="img-fluid rounded border"
                        style={{ aspectRatio: "1/1", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <button className="saveChanges-button" onClick={handleSubmit}>Submit</button>
      </div>

      {deleteImageModal && (
        <DeleteImageModal id={selectedImage.id} cancelModal={cancelModal} fetchData={fetchData} />
      )}
      {uploadImageModal && (
        <UploadImageModal cancelModal={cancelModal} fetchData={fetchData} />
      )}
      {uploadProfileImgModal && (
        <UploadProfileImgModal reviewPendingClub={fetchData} cancelModal={cancelModal} fetchData={fetchData} />
      )}
      {deletePropfileImgModal && (
        <DeleteProfileImgModal reviewPendingClub={reviewPendingClub} cancelModal={cancelModal} fetchData={fetchData} />
      )}
    </div>
  );
}
